import type { TextFieldProps } from '@mui/material/TextField';
import {
	DatePickerProps,
	DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { RefObject } from 'react';

const {
	navigator: { language },
} = window;

export interface CustomDatePickerProps extends DatePickerProps {
	size: TextFieldProps['size'];
	ref?: RefObject<HTMLDivElement>;
}

/**
 * ```ts
 * Date picker will always save date as UTC, since we can disregard time.
 * ```
 */
export const DatePicker = ({ ref, ...props }: CustomDatePickerProps) => (
	<LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={language}>
		<MuiDatePicker {...props} ref={ref} timezone="UTC" />
	</LocalizationProvider>
);
